module.exports = "<div id=\"flashMessages\">\n  <div class=\"flash-message alert {{findClass(message)}}\" *ngFor='let message of messages'>\n    <div [innerHtml]=\"message.message\"></div>\n    <button class=\"close\" *ngIf=\"showClose(message)\" (click)=\"closeMessage(message)\">\n      <span>{{ 'COMMON.BUTTON.CLOSE' | translate }}</span>\n    </button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/flash-messages/component/flash.messages.component.html
// module id = vFLc
// module chunks = 0